module.exports = __webpack_public_path__ + "static/covid-for-individuals-6c28c005fe8dba7ab30deb73ba6974e1.jpg";